import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function PrivacyAziendaPage() {
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);
  const [savedAt, setSavedAt] = useState(null);

  const carica = async () => {
    setLoading(true); setErr(null);
    try {
      const r = await api.get("/azienda");
      setDoc(r.data?.azienda || {});
    } catch (e) { setErr(e.response?.data?.detail || "Errore"); }
    finally { setLoading(false); }
  };
  useEffect(() => { carica(); }, []);

  const salva = async () => {
    setSaving(true); setErr(null);
    try {
      await api.put("/azienda", doc);
      setSavedAt(new Date());
    } catch (e) { setErr(e.response?.data?.detail || "Errore salvataggio"); }
    finally { setSaving(false); }
  };

  const upd = (k, v) => setDoc({ ...doc, [k]: v });

  if (loading || !doc) {
    return <div style={{ padding: 30, textAlign: "center", color: "#888" }}>Caricamento...</div>;
  }

  return (
    <div style={{ padding: 16, maxWidth: 800 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
        <h2 style={{ margin: 0, fontSize: 18, color: "#37474f" }}>🏢 Azienda</h2>
        <span style={{ fontSize: 11, color: "#666" }}>
          Anagrafica dell'ente. Questi dati popolano l'intestazione PI1..5 dei modelli stampati.
        </span>
        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 10, fontSize: 11 }}>
          {saving && <span>💾 Salvataggio...</span>}
          {!saving && savedAt && <span style={{ color: "#1b5e20" }}>✓ Salvato alle {savedAt.toLocaleTimeString()}</span>}
        </div>
      </div>

      {err && <div style={{ padding: 10, background: "#fff0f0", color: "#c00", fontSize: 12, marginBottom: 10 }} data-testid="pa-error">{err}</div>}

      <div style={{ background: "white", border: "1px solid #ccc", padding: 20, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        <Field label="Ragione sociale" testid="pa-f-rs" full>
          <input type="text" value={doc.ragione_sociale || ""} onChange={e => upd("ragione_sociale", e.target.value)} data-testid="pa-i-rs" style={inp} />
          <Hint>→ stampato come <code>«PI1»</code></Hint>
        </Field>
        <Field label="Sede (indirizzo completo)" testid="pa-f-sede" full>
          <input type="text" value={doc.sede || ""} onChange={e => upd("sede", e.target.value)} data-testid="pa-i-sede" style={inp} />
          <Hint>→ stampato come <code>«PI2»</code></Hint>
        </Field>
        <Field label="Codice Fiscale" testid="pa-f-cf">
          <input type="text" value={doc.codice_fiscale || ""} onChange={e => upd("codice_fiscale", e.target.value)} data-testid="pa-i-cf" style={inp} />
        </Field>
        <Field label="Partita IVA" testid="pa-f-piva">
          <input type="text" value={doc.partita_iva || ""} onChange={e => upd("partita_iva", e.target.value)} data-testid="pa-i-piva" style={inp} />
        </Field>
        <Field label="Telefono" testid="pa-f-tel">
          <input type="text" value={doc.telefono || ""} onChange={e => upd("telefono", e.target.value)} data-testid="pa-i-tel" style={inp} />
          <Hint>→ stampato come <code>«PI4»</code></Hint>
        </Field>
        <Field label="Email" testid="pa-f-mail">
          <input type="email" value={doc.email || ""} onChange={e => upd("email", e.target.value)} data-testid="pa-i-mail" style={inp} />
          <Hint>→ stampato come <code>«PI5»</code></Hint>
        </Field>
        <div style={{ gridColumn: "1 / -1", marginTop: 8, padding: "8px 10px", background: "#fff8e1", border: "1px solid #ffe082", fontSize: 11, color: "#5d4037" }}>
          ℹ️ <code>«PI3»</code> viene generato automaticamente combinando C.F. e P.IVA.
        </div>
        <div style={{ gridColumn: "1 / -1", display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
          <button onClick={salva} disabled={saving} data-testid="pa-save"
            style={{ padding: "8px 20px", background: "#2e7d32", color: "white", border: "none", fontSize: 13, fontWeight: 700, cursor: saving ? "wait" : "pointer" }}>
            💾 Salva
          </button>
        </div>
      </div>
    </div>
  );
}

const inp = { width: "100%", padding: "7px 10px", border: "1px solid #ccc", fontSize: 12, boxSizing: "border-box" };

function Field({ label, testid, children, full }) {
  return (
    <div style={{ gridColumn: full ? "1 / -1" : "auto" }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: "#555", marginBottom: 3 }} data-testid={testid}>{label}</div>
      {children}
    </div>
  );
}
const Hint = ({ children }) => <div style={{ fontSize: 10, color: "#888", marginTop: 2 }}>{children}</div>;
